import {
  DataEntryVehicleStepSectionPropsWithStep,
  ImpactPoint,
  typedMemo,
} from "src/types";
import { useVehicleImpactPointsGrid } from "./vehicle-impact-points-grid.hook";
import { VehicleImpactPointCell } from "./vehicle-impact-point-cell";

export const VehicleImpactPointsGrid = typedMemo(
  (props: DataEntryVehicleStepSectionPropsWithStep) => {
    const {
      fillColor,
      opacityColor,
      borderColor,
      VEHICLE_POINTS,
      GRID_LAYOUT,
      handlePointClick,
      isPointSelected,
    } = useVehicleImpactPointsGrid(props);

    return (
      <div className=" rounded-2xl">
        <div className="impact-points-grid">
          {GRID_LAYOUT.map((row, rowIndex) =>
            row.map((point, colIndex) => (
              <VehicleImpactPointCell
                key={`${rowIndex}-${colIndex}`}
                impactPoint={point}
                svgSrc={point ? VEHICLE_POINTS[point] : ""}
                isSelected={point ? isPointSelected(point) : false}
                onClick={
                  point == ImpactPoint.PLACEHOLDER
                    ? () => {}
                    : () => point && handlePointClick(point)
                }
                fillColor={fillColor}
                opacityColor={opacityColor}
                borderColor={borderColor}
              />
            )),
          )}
        </div>
      </div>
    );
  },
);
